module.exports = __webpack_public_path__ + "img/microbasurales.94d5c3a8.png";